import { createContext, useContext, useState } from "react";
import type { TabsContextType } from "./TabsContextType";

const TabsContext = createContext<TabsContextType | undefined>(undefined);

export const useTabsContext = () => {
    const context = useContext(TabsContext);

    if (!context) throw new Error("useTabsContext must be used inside TabsProvider");
    return context;
};

export const TabsProvider = ({ children }: { children: React.ReactNode }) => {
    const [activeTabKey, setActiveTabKey] = useState("AnalysisAgent");
    const [id, setId] = useState("");
    const [valuesByDefault, setValuesByDefault] = useState([])
    
    return (
        <TabsContext.Provider
            value={{
                activeTabKey, setActiveTabKey,
                id, setId,
                valuesByDefault, setValuesByDefault
            }}>
            {children}
        </TabsContext.Provider>
    );
};
